import React from 'react';
import { ResponseContainer } from './DisplayContainer';
import styled from 'styled-components';

const ChoiceDisplay = (props) => {
  const { listOfAnswers } = props;

  return (
    <>
      {listOfAnswers?.map((option) => {
        return (
          <ResponseContainer>
            <SDiv>{option?.coding?.display}</SDiv>
          </ResponseContainer>
        );
      })}
    </>
  );
};

export default ChoiceDisplay;

const SDiv = styled.div`
  && {
    margin: 0 5px;
  }
`;
